var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('audio',{ref:"audio",attrs:{"src":_vm.url,"autoplay":_vm.isplay,"loop":!_vm.mode,"crossorigin":"anonymous","preload":"auto"},on:{"timeupdate":_vm.timeUpdate,"ended":_vm.next,"error":_vm.httpError}})])}
var staticRenderFns = []

export { render, staticRenderFns }